//
// dropzone.js
//

import Dropzone from 'dropzone';

// Make available globally for users of the /dist folder
// Feel free to comment this out if you're working in the /src folder
window.Dropzone = Dropzone;
